<template>
  <!-- 劳动量管理：布局与推荐值管理一致，统一使用AnkhList与TableList -->
  <ankh-list>
    <template #btn-group>
      <el-button type="primary" @click.native="handleAdd">{{$t('新增')}}</el-button>
      <el-button @click.native="handleBatchDelete">{{$t('批量删除')}}</el-button>
    </template>

    <!-- 搜索表单区：遵循系统统一表单间距、大小与布局 -->
    <template #search-form>
      <!-- 名称搜索 -->
      <el-form-item :label="$t('名称')">
        <el-input v-model="searchForm.name" clearable :placeholder="$t('名称')" />
      </el-form-item>
      <!-- 操作按钮与统一交互 -->
      <el-form-item>
        <el-button type="primary" size="small" @click="$refs.list.handleSearch()">{{ $t('搜索') }}</el-button>
        <el-button size="small" @click="$refs.list.reset()">{{ $t('重置') }}</el-button>
      </el-form-item>
    </template>

    <!-- 表格区：系统封装TableList，接入高度传递、选择与查询事件 -->
    <template #table="{height}">
      <table-list
          ref="list"
          :height="height"
          @query="handleSearch"
          :request-params="{refRecommend: $route.query.code}"
          :search-params="searchForm"
          :data="tableData"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50" />
        <el-table-column type="index" :label="$t('序号')" width="60" fixed />

        <el-table-column prop="name" :label="$t('名称')" min-width="180" />
        <el-table-column :label="$t('关联推荐算法')" prop="refRecommendName" min-width="180"/>
        <el-table-column :label="$t('男性推荐值')" min-width="150">
          <template v-slot="{row}">
            <span v-if="row.manRecommendMin != null && row.manRecommendMax != null">
              {{ row.manRecommendMin }} ~ {{ row.manRecommendMax }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('女性推荐值')" min-width="150">
          <template v-slot="{row}">
            <span v-if="row.womanRecommendMin != null && row.womanRecommendMax != null">
              {{ row.womanRecommendMin }} ~ {{ row.womanRecommendMax }}
            </span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('更新时间')" min-width="180">
          <template v-slot="{row}">
            {{ row.updateTime | formatDate }}
          </template>
        </el-table-column>

        <el-table-column :label="$t('操作')" width="200" fixed="right" align="center">
          <template v-slot="{row}">
            <div class="fb-link-flex">
              <el-link :underline="false" type="primary" @click="handleEdit(row)">{{ $t('编辑') }}</el-link>
              <el-link :underline="false" type="danger" @click="handleDelete(row)">{{ $t('删除') }}</el-link>
            </div>
          </template>
        </el-table-column>

      </table-list>
    </template>

    <!-- 弹窗区：预留新增/编辑表单弹窗位点，保持统一行为与间距 -->
    <template #other>
      <el-dialog :visible.sync="showDialog" :title="dialogTitle" :close-on-click-modal="false" width="520px" @close="resetDialog" class="workload-dialog">
        <el-form :model="form" :rules="rules" ref="form" class="compact-form">
          <el-form-item :label="$t('名称')" prop="name">
            <el-input v-model="form.name" :placeholder="$t('名称')" />
          </el-form-item>
          <el-form-item :label="$t('男性推荐值')" prop="manRecommendRange">
            <div class="range-input-row">
              <el-input-number
                v-model="form.manRecommendMin"
                controls-position="right"
                :placeholder="$t('最小值')"
                @blur="handleManMinBlur"
              />
              <span class="range-separator">~</span>
              <el-input-number
                v-model="form.manRecommendMax"
                controls-position="right"
                :placeholder="$t('最大值')"
                @blur="handleManMaxBlur"
              />
            </div>
          </el-form-item>
          <el-form-item :label="$t('女性推荐值')" prop="womanRecommendRange">
            <div class="range-input-row">
              <el-input-number
                v-model="form.womanRecommendMin"
                controls-position="right"
                :placeholder="$t('最小值')"
                @blur="handleWomanMinBlur"
              />
              <span class="range-separator">~</span>
              <el-input-number
                v-model="form.womanRecommendMax"
                controls-position="right"
                :placeholder="$t('最大值')"
                @blur="handleWomanMaxBlur"
              />
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="showDialog = false">{{ $t('取消') }}</el-button>
          <el-button type="primary" @click="handleSubmit">{{ $t('确定') }}</el-button>
        </span>
      </el-dialog>
    </template>
  </ankh-list>
</template>

<script>
import AnkhList from '@/components/list/AnkhList.vue'
import TableList from '@/components/table-list/TableList'
import { request, requestByTip } from '@/config/request'

export default {
  name: 'WorkloadManageList',
  components: {AnkhList, TableList },
  data() {
    return {
      // 搜索表单
      searchForm: {
        name: '',
      },
      // 表格数据
      tableData: [],
      // 选择项
      selection: [],
      // 弹窗
      showDialog: false,
      isEdit: false,
      form: {
        name: '',
        code: '',
        refRecommend: '',
        valid: 1,
        manRecommendMin: null,
        manRecommendMax: null,
        womanRecommendMin: null,
        womanRecommendMax: null,
      },
      // 表单校验规则
      rules: {
        name: [{ required: true, message: this.$t('请输入名称'), trigger: 'blur' }],
        manRecommendRange: [
          { required: true, message: this.$t('请输入男性推荐值'), trigger: 'blur', validator: this.validateManRecommendRange }
        ],
        womanRecommendRange: [
          { required: true, message: this.$t('请输入女性推荐值'), trigger: 'blur', validator: this.validateWomanRecommendRange }
        ],
      },
    }
  },
  methods: {
    // 查询列表：保持与系统TableList事件对接
    async handleSearch(params, setTotal) {
      try {
        // 合并搜索与分页参数；request封装会过滤空值
        const query = Object.assign({}, params)
        const resp = await request(this.$api.labor.list, query)
        this.tableData = resp.labors || []
        setTotal(resp.pager?.itemCount);
      } catch (e) {
        // 静默失败，交由request内部提示
        console.error(this.$t('查询劳动量列表失败:'), e)
      }
    },
    // 新增
    handleAdd() {
      this.isEdit = false
      this.showDialog = true
      this.form = {
        id: undefined,
        name: '',
        code: '',
        refRecommend: this.$route.query.code,
        manRecommendMin: null,
        manRecommendMax: null,
        womanRecommendMin: null,
        womanRecommendMax: null,
      }
    },
    // 编辑
    handleEdit(row) {
      this.isEdit = true
      this.showDialog = true
      this.form = Object.assign({}, row)
    },
    // 删除
    async handleDelete(row) {
      try {
        await requestByTip(this.$api.labor.delete, { code: row.code })
        this.$message.success(this.$t('删除成功'))
        this.$refs.list && this.$refs.list.handleSearch && this.$refs.list.handleSearch()
      } catch (e) {
        console.error(this.$t('删除失败:'), e)
      }
    },
    // 批量删除
    async handleBatchDelete() {
      if (!this.selection || !this.selection.length) {
        this.$message.warning(this.$t('请选择需要删除的记录'))
        return
      }
      try {
        const codes = this.selection.map(it => it.code)
        await requestByTip(
          this.$api.labor.batchDelete,
          codes,
          { isJson: true },
          { message: this.$t('您现在正在进行批量删除操作, 是否继续?') }
        )
        this.$message.success(this.$t('删除成功'))
        this.$refs.list && this.$refs.list.handleSearch && this.$refs.list.handleSearch()
      } catch (e) {
        console.error(this.$t('批量删除失败:'), e)
      }
    },
    // 提交（新增/编辑）
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        const api = this.isEdit ? this.$api.labor.update : this.$api.labor.add
        await request(api, this.form)
        this.$message.success(this.$t('保存成功'))
        this.showDialog = false
        this.$refs.list && this.$refs.list.handleSearch && this.$refs.list.handleSearch()
      } catch (e) {
        console.error(this.$t('保存失败:'), e)
      }
    },
    // 男性最小值输入处理：同步到最大值
    handleManMinBlur() {
      if (this.form.manRecommendMin !== null && this.form.manRecommendMin !== undefined) {
        if (this.form.manRecommendMax === null || this.form.manRecommendMax === undefined) {
          this.form.manRecommendMax = this.form.manRecommendMin
        } else if (this.form.manRecommendMin > this.form.manRecommendMax) {
          this.form.manRecommendMax = this.form.manRecommendMin
        }
      }
      // 触发验证
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.validateField('manRecommendRange')
      })
    },
    // 男性最大值输入处理：自动调整并触发验证
    handleManMaxBlur() {
      // 如果最大值小于最小值，自动将最小值调整为最大值
      if (this.form.manRecommendMax !== null && this.form.manRecommendMax !== undefined && 
          this.form.manRecommendMin !== null && this.form.manRecommendMin !== undefined &&
          this.form.manRecommendMax < this.form.manRecommendMin) {
        this.form.manRecommendMin = this.form.manRecommendMax
      }
      // 触发验证
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.validateField('manRecommendRange')
      })
    },
    // 女性最小值输入处理：同步到最大值
    handleWomanMinBlur() {
      if (this.form.womanRecommendMin !== null && this.form.womanRecommendMin !== undefined) {
        if (this.form.womanRecommendMax === null || this.form.womanRecommendMax === undefined) {
          this.form.womanRecommendMax = this.form.womanRecommendMin
        } else if (this.form.womanRecommendMin > this.form.womanRecommendMax) {
          this.form.womanRecommendMax = this.form.womanRecommendMin
        }
      }
      // 触发验证
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.validateField('womanRecommendRange')
      })
    },
    // 女性最大值输入处理：自动调整并触发验证
    handleWomanMaxBlur() {
      // 如果最大值小于最小值，自动将最小值调整为最大值
      if (this.form.womanRecommendMax !== null && this.form.womanRecommendMax !== undefined && 
          this.form.womanRecommendMin !== null && this.form.womanRecommendMin !== undefined &&
          this.form.womanRecommendMax < this.form.womanRecommendMin) {
        this.form.womanRecommendMin = this.form.womanRecommendMax
      }
      // 触发验证
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.validateField('womanRecommendRange')
      })
    },
    // 验证男性推荐值
    validateManRecommendRange(rule, value, callback) {
      if (!this.form.manRecommendMin && this.form.manRecommendMin !== 0) {
        callback(new Error(this.$t('请输入男性推荐最小值')))
        return
      }
      if (!this.form.manRecommendMax && this.form.manRecommendMax !== 0) {
        callback(new Error(this.$t('请输入男性推荐最大值')))
        return
      }
      callback()
    },
    // 验证女性推荐值
    validateWomanRecommendRange(rule, value, callback) {
      if (!this.form.womanRecommendMin && this.form.womanRecommendMin !== 0) {
        callback(new Error(this.$t('请输入女性推荐最小值')))
        return
      }
      if (!this.form.womanRecommendMax && this.form.womanRecommendMax !== 0) {
        callback(new Error(this.$t('请输入女性推荐最大值')))
        return
      }
      callback()
    },
    // 重置弹窗
    resetDialog() {
      this.$nextTick(() => {
        this.$refs.form && this.$refs.form.clearValidate && this.$refs.form.clearValidate()
      })
    },
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? this.$t('编辑') : this.$t('新增')
    }
  }
}
</script>

<style scoped>
.range-input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

.range-separator {
  color: #606266;
  font-weight: 500;
}

.compact-form .el-form-item {
  margin-bottom: 18px;
}

.compact-form .el-form-item__label {
  font-weight: 500;
  color: #303133;
}

.workload-dialog .el-dialog__body {
  padding: 20px 20px 10px;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .range-input-row {
    flex-direction: column;
    gap: 4px;
    align-items: stretch;
  }
  
  .range-input-row .el-input-number {
    width: 100%;
  }
}
</style>



